/*
 * Geschenk-Freischaltung im Warenkorb (siehe snippets/cart-gift.liquid).
 * Klick auf "Geschenk freischalten": setzt den Rabattcode per /discount/<code> (Cookie, wird im Checkout
 * automatisch angewendet) und zeigt den Code sofort an. Danach rendert der Warenkorb den aktiven Zustand
 * selbst (Liquid erkennt den angewendeten Code), deshalb ist hier kein Zwischenspeicher nötig.
 * Klick-Delegation auf document, damit es nach jedem Neu-Rendern des Drawers funktioniert.
 */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tsb-gift-unlock]');
    if (!button) return;
    var box = button.closest('.tsb-gift');
    var code = box && box.dataset.giftCode;
    if (!code) return;
    button.disabled = true;
    // Rabattcode über den /discount/-Link setzen; redirect auf cart.js hält die Antwort klein
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
      .catch(function () {})
      .then(function () {
        box.classList.add('is-unlocked');
        var panel = box.querySelector('.tsb-gift__reveal');
        if (panel) panel.hidden = false;
      });
  });
})();
